import { FC } from 'react';
import { ButtonConfig } from '../types';
import Button from 'v3/common/components/Button';

interface TipButtonProps {
  buttonConfig: ButtonConfig;
  onClick: () => void;
}

const TipButton: FC<TipButtonProps> = ({ buttonConfig, onClick }) => {
  return (
    <div className="tips-modal__footer">
      <Button onClick={onClick}>{buttonConfig.btn_text || 'Learn More'}</Button>
    </div>
  );
};

export default TipButton;
